module.exports = __webpack_public_path__ + "assets/img/00154.35bf0c6f.png";